import { gql } from 'graphql-request';

import { MaterialsSetUUID } from '../materialsSetsTypes';

export interface DownloadMaterialsSetQueryResponse {
  uuid: MaterialsSetUUID;
}

export const DOWNLOAD_MATERIALS_SET_QUERY = gql`
  mutation DownloadMaterialsSet($uuid: ID!, $deviceNanoId: String!) {
    downloadMaterialsSet(input: { uuid: $uuid, deviceNanoId: $deviceNanoId }) {
      recordUuid
      status
      record {
        uuid
      }
      errors {
        fullMessages
      }
    }
  }
`;
